module.exports = __webpack_public_path__ + "static/02-un-0506086@2x-b250b6247e3ebbaaffcb2754d3508ee6.png";